export default __webpack_public_path__ + "static/media/1.0ce92b5c.png";